import { useCallback, useMemo, useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslations } from '@lang';

import { SpaPackageFormValues } from '../../SpaPackageForm.schema';

type UsePreferencesParams = {
  form: UseFormReturn<SpaPackageFormValues>;
};

export function usePreferences({ form }: UsePreferencesParams) {
  const { t } = useTranslations();
  const [noteValue, setNoteValue] = useState('');

  const handleFreeTextChange = useCallback(
    (_categoryId: string, value: string) => {
      setNoteValue(value);
      form.setValue('note', value);
    },
    [form]
  );

  const preferenceCategories = useMemo(
    () => [
      {
        id: 'notes',
        label: t('additional.notes'),
        isFreeText: true,
        freeTextPlaceholder: t('booking.additionnalNotesPlaceholder'),
        freeTextValue: noteValue,
      },
    ],
    [t, noteValue]
  );

  return {
    handleFreeTextChange,
    preferenceCategories,
  };
}
